
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as help_kESVLdeO5OvXwnbZat3m9oyEM1XkcDYK0p0NbvrqswMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/help.vue?macro=true";
import { default as lojajSZ_rLATBnJkrTadFKF5LqoNtLiOV58Zxs9l__lvCUEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/loja.vue?macro=true";
import { default as indexkt28AC_h80lAhxFIbN4p4pN5H_8BCacqE1qX4IHUV6sMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/index.vue?macro=true";
import { default as signupfrBKUPkTTyZM257iJvhjlpp3wr9Jm4sBu4_NQqA596kMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/signup.vue?macro=true";
import { default as contactm2tLVq7165bIkUXoGN1n9ZquxOgKxHg7osbtGG_Qf40Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/contact.vue?macro=true";
import { default as missoes9Q7W3pduJhQrv7TlWk8DOrKb0U9nfOwe8wc_nCJTXnAMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/missoes.vue?macro=true";
import { default as pendingOoMFCJyrj_1qn2_YFgDgchg_F4PVx5GmjbKiYDPI_fYMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/pending.vue?macro=true";
import { default as footerDZI81nVwdW_Vnq50bRZEYQqNDoB5RtdRz9kQY_Q6GzYMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/_/footer.vue?macro=true";
import { default as registerXQMNQBs3Gt7OwmZSxHJKNQORkaVWp5XdQa_kcqwioAEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/register.vue?macro=true";
import { default as sponsors1ZgKvZyi_fvlCzuEEXpvRPq_LkuxjDOMjQCSyHMEMTcMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/sponsors.vue?macro=true";
import { default as irpfzR8W_L2aG3yse5hXzb0ATFxwFAoi0k8eYwTeCARCkG0Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/irpf.vue?macro=true";
import { default as indexMiSCDmZ9gyGzvUUe9X_Khsxhl9qhbwjQlTE39CL_3zcMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/index.vue?macro=true";
import { default as storeuPHLaK13do2WXLm3PtM3UPLAurnFWYCMD_wb_Pl0ydgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/store.vue?macro=true";
import { default as index5v5FpyeH6HuOq0qro__t1RCv_Oq_Vj8GyCuQodtF4tEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/blog/index.vue?macro=true";
import { default as game_45errorGUFlI7N6tLwvdRxiKiRLSBM0sP9qAXsmDYkCiFVdvA8Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/game-error.vue?macro=true";
import { default as liveLfXsd0M5kR2DQ0TNcodocxnSUE3CzP8BBBjNQSc5emEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/live.vue?macro=true";
import { default as playnNPk1jXGNWynfidM_FFkZwRvQBqFLisRmVymcLft4aMMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/poker/play.vue?macro=true";
import { default as badgesODDQtOem_aV3kJUwtRO8sqrLkwkbdLyBzTpRIbMnnkQMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/badges.vue?macro=true";
import { default as levelsoBTBaohCRsLvMct27dpvUQGQtfMCIJZzDNZ6w3psXBQMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/levels.vue?macro=true";
import { default as _91post_93Ucc9jyPF1qnAswh5QBRlfIT0pMdbIkhYJfWetbKrh50Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/blog/[post].vue?macro=true";
import { default as indexsf_qGutlJCrgUru_6pBCTj_MAStOSIaJgKY7yZ5Bj6oMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/index.vue?macro=true";
import { default as indexlM_0Qe8T42JV_SyBfMFOjcCTaZYHXYrhEEmVhqX8GWYMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/login/index.vue?macro=true";
import { default as maintenanceUe82s0rjr93tY16aiN4cgcYHA_VjnfqGCVIzbr6cMmwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/maintenance.vue?macro=true";
import { default as _91term_93PL_om_KVceaPR5_bhazj_nE24c9NgY966sGVRkvUeBoMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/page/[term].vue?macro=true";
import { default as indexBQEfbmVERWqF0PD9ZosT2Sc8Trer70IB7cuUJFw8U_oMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/poker/index.vue?macro=true";
import { default as refers45Z7NLgfh4t09zWy5ZR5WDQuqr16607gUeTz_paD0asMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/refers.vue?macro=true";
import { default as _91code_93TOGDRxDIWHVKJWI0JC4158w1RxOA9rwsetmRwJeGRVYMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/error/[code].vue?macro=true";
import { default as accountX4_jKBtndOpwdzur8Uq004iUqffzU5wQvXdedyl7__YMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/account.vue?macro=true";
import { default as profile_pcEopB2QvfhtJ4Gl__qWqs6m7RRRkSVDklXkDB4WJgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/profile.vue?macro=true";
import { default as rewardsUeUYhCHs5aEZsSgrsWBot22VcD0aZb59ohQPuVr3RTgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/rewards.vue?macro=true";
import { default as missions4oqcwNFsN_s2AfXAY_tmC9yhgICZJKdWs09Jh34m6qwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/missions.vue?macro=true";
import { default as _91cupom_93yttNv8ZQ9AfLejucG31800nQTCg5mFcs0hKX40zrvwkMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/cupom/[cupom].vue?macro=true";
import { default as securityhVxNIvSd_K5rDpvmEVp5SErMpZnqbI1X96uQnmb7ppwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/security.vue?macro=true";
import { default as mini_45gamesk22P9Jdz5HQArN5t7N_rWzVVhQBgLNrfVdURMXXwOzQMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/mini-games.vue?macro=true";
import { default as forgot_45passwordelySWKjYQf2UUh294xDAtncWabcGI2kFYdayFO3CGhQMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/forgot-password.vue?macro=true";
import { default as confirmbJfiS5AMQ7hn9mDzxNLsj4gKP_WMI_NW1qHgPNneu80Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/migrate/confirm.vue?macro=true";
import { default as _91id_93ff5oa9bTYnEzAY5eXogpwaL2_wqh9rIFum4f6GV2VMQMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/mini-games/[id].vue?macro=true";
import { default as indexOfWaVxLGVsXejbmlrTKR_LZ6mO3S8AqI4LGZSabcCjkMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promocode/index.vue?macro=true";
import { default as two_45factorIgZFelg4EagTYhCKArEmGKE4wiumuA0WCK20wlqaE54Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/login/two-factor.vue?macro=true";
import { default as indexOpRX3A5t6SM3qjT_W5p2mJcZhvB0t11VQo5cjFbGrOkMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promotions/index.vue?macro=true";
import { default as fullwmyDtzO4xzDWF1GpZVZLeBWjGiXTVe1tTyGU_X0LlqwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/full.vue?macro=true";
import { default as indexVCdD54zQHmkExaP5gf8rdVuyXt7kF7_Rv42r9LRYIWcMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/index.vue?macro=true";
import { default as _91_46_46_46casino_93ZZ92Q7hVJDt92BABr2CzXy_cMuks0WphqjYcxKAWyHwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/casino/[...casino].vue?macro=true";
import { default as _91_46_46_46sports_93sNtD4sUPqcqhTmxomHczuWHUyHQH_p_3qNRF63cYi_wMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/sports/[...sports].vue?macro=true";
import { default as poker9PId_6lUkDcdrrCZSfkl8LbS7vO3AtATenwaIsw6LUgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/poker.vue?macro=true";
import { default as login_45history9vNV_fIQEzqt78V2CZj0QEyDsXqK1GxMTSECrXYFxH4Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/login-history.vue?macro=true";
import { default as notificationseIKCFR1K60cWThVrYgOEjqySxvCABMkh0h1qTdafMccMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/notifications.vue?macro=true";
import { default as casinojdYacrpppuLyOG9MPw0kypIOE97OHk4kgSHaQ6m7QGEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/casino.vue?macro=true";
import { default as sports13xNVS_X12jrmeKkIxfoagyroMnh5MhQS3pr0o2tX3MMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/sports.vue?macro=true";
import { default as index9Z5iA1rSutl349_VC1gIN1gEQEKPX4Qs1Edhk7ClBa8Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/perfil-oficial/index.vue?macro=true";
import { default as indexA4nO6sue087bLOce2pL67CmGJR5HdCfPM4DxLlARjdwMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/providers/index.vue?macro=true";
import { default as irpf_45rendimentosoHg5V14ADpdSez_J2bn_qQsSfOkAi2Skgu2tH9_dMvgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/irpf-rendimentos.vue?macro=true";
import { default as indexyvjlgPkTWGMUr22drhq8gFuuafqaGu4eF_ngyCg2rhgMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/tournaments/index.vue?macro=true";
import { default as _91promotion_93FodXc72ax7ymlzUGxu9dofSV5txmLRArVRoIUwTySDcMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promotions/[promotion].vue?macro=true";
import { default as _91game_93wvtsxY2c0IRn1AG9r9EoI4YTGKxQIbe3K9_Zt2DyEXoMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/[provider]/[game].vue?macro=true";
import { default as jogos_45do_45padrinhoukWPxi_8tcu2kXw6770jAMe0oclcDpEZzBWFDeQbe68Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/jogos-do-padrinho.vue?macro=true";
import { default as _91perfil_93HJ8VrenKRURe5lSYBiaE6o3bX_wHkMzZgIGnuDe3I68Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/perfil-oficial/[perfil].vue?macro=true";
import { default as account_45protection5aUJDjvnbnRVDrGUuUF8hxtaVwDwXv3sT1GVa0FzqoIMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/account-protection.vue?macro=true";
import { default as _91sectionSlug_93M0iValyXTruwq5VO3CkPfYA3IpCNmIPgUMJeiQ936MsMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/ver-todos/[sectionSlug].vue?macro=true";
import { default as self_45exclusionh5SAaFkuR4cSgEHq8OTAwQuxOSxUDArCVJR8ujIm20YMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/self/self-exclusion.vue?macro=true";
import { default as transactions5lsQFkG_s3N3lfK9vojHUzbXjpV69JS7uGTslBwxOC8Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/transactions.vue?macro=true";
import { default as last_45withdrawNnelzvOakH6XDzr3mILr3AHCrsEBmI9Xi3i2VcDgBa8Meta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/last-withdraw.vue?macro=true";
import { default as _91provider_93kNX1_azNez8k5xkIDSS9gxWsxKN0mV77jVtoRQ8HNRkMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/providers/[provider].vue?macro=true";
import { default as _91_46_46_46category_93CP6759qObsZt_nweXmrjGFdVXApfi8fZe9WfrtPtK7AMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/category/[...category].vue?macro=true";
import { default as _91token_93XVZmVSh8AWLnBy3vVqguDlybpLoZApj2KqY6BKIHbWIMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/validate/[type]/[token].vue?macro=true";
import { default as _91tournament_93MEFy70rVMl2sjLnB_J2L4jIN7hmxUzmI7I42oXkguAEMeta } from "/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/tournaments/[tournament].vue?macro=true";
export default [
  {
    name: "help",
    path: "/help",
    meta: help_kESVLdeO5OvXwnbZat3m9oyEM1XkcDYK0p0NbvrqswMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/help.vue")
  },
  {
    name: "loja",
    path: "/loja",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/loja.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/index.vue")
  },
  {
    name: "signup",
    path: "/signup",
    meta: signupfrBKUPkTTyZM257iJvhjlpp3wr9Jm4sBu4_NQqA596kMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/contact.vue")
  },
  {
    name: "missoes",
    path: "/missoes",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/missoes.vue")
  },
  {
    name: "pending",
    path: "/pending",
    meta: pendingOoMFCJyrj_1qn2_YFgDgchg_F4PVx5GmjbKiYDPI_fYMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/pending.vue")
  },
  {
    name: "_-footer",
    path: "/_/footer",
    meta: footerDZI81nVwdW_Vnq50bRZEYQqNDoB5RtdRz9kQY_Q6GzYMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/_/footer.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerXQMNQBs3Gt7OwmZSxHJKNQORkaVWp5XdQa_kcqwioAEMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/register.vue")
  },
  {
    name: "sponsors",
    path: "/sponsors",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/sponsors.vue")
  },
  {
    name: "user-irpf",
    path: "/user/irpf",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/irpf.vue")
  },
  {
    name: "vip",
    path: "/vip",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/index.vue")
  },
  {
    name: "vip-store",
    path: "/vip/store",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/store.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/blog/index.vue")
  },
  {
    name: "game-error",
    path: "/game-error",
    meta: game_45errorGUFlI7N6tLwvdRxiKiRLSBM0sP9qAXsmDYkCiFVdvA8Meta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/game-error.vue")
  },
  {
    name: "games-live",
    path: "/games/live",
    meta: liveLfXsd0M5kR2DQ0TNcodocxnSUE3CzP8BBBjNQSc5emEMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/live.vue")
  },
  {
    name: "poker-play",
    path: "/poker/play",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/poker/play.vue")
  },
  {
    name: "vip-badges",
    path: "/vip/badges",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/badges.vue")
  },
  {
    name: "vip-levels",
    path: "/vip/levels",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/levels.vue")
  },
  {
    name: "blog-post",
    path: "/blog/:post()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/blog/[post].vue")
  },
  {
    name: "games",
    path: "/games",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexlM_0Qe8T42JV_SyBfMFOjcCTaZYHXYrhEEmVhqX8GWYMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/login/index.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: maintenanceUe82s0rjr93tY16aiN4cgcYHA_VjnfqGCVIzbr6cMmwMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/maintenance.vue")
  },
  {
    name: "page-term",
    path: "/page/:term()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/page/[term].vue")
  },
  {
    name: "poker",
    path: "/poker",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/poker/index.vue")
  },
  {
    name: "user-refers",
    path: "/user/refers",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/refers.vue")
  },
  {
    name: "error-code",
    path: "/error/:code()",
    meta: _91code_93TOGDRxDIWHVKJWI0JC4158w1RxOA9rwsetmRwJeGRVYMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/error/[code].vue")
  },
  {
    name: "user-account",
    path: "/user/account",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/account.vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/profile.vue")
  },
  {
    name: "user-rewards",
    path: "/user/rewards",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/rewards.vue")
  },
  {
    name: "vip-missions",
    path: "/vip/missions",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/missions.vue")
  },
  {
    name: "cupom-cupom",
    path: "/cupom/:cupom()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/cupom/[cupom].vue")
  },
  {
    name: "user-security",
    path: "/user/security",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/security.vue")
  },
  {
    name: "vip-mini-games",
    path: "/vip/mini-games",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/mini-games.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordelySWKjYQf2UUh294xDAtncWabcGI2kFYdayFO3CGhQMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/forgot-password.vue")
  },
  {
    name: "migrate-confirm",
    path: "/migrate/confirm",
    meta: confirmbJfiS5AMQ7hn9mDzxNLsj4gKP_WMI_NW1qHgPNneu80Meta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/migrate/confirm.vue")
  },
  {
    name: "mini-games-id",
    path: "/mini-games/:id()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/mini-games/[id].vue")
  },
  {
    name: "promocode",
    path: "/promocode",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promocode/index.vue")
  },
  {
    name: "login-two-factor",
    path: "/login/two-factor",
    meta: two_45factorIgZFelg4EagTYhCKArEmGKE4wiumuA0WCK20wlqaE54Meta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/login/two-factor.vue")
  },
  {
    name: "promotions",
    path: "/promotions",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promotions/index.vue")
  },
  {
    name: "user-history-full",
    path: "/user/history/full",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/full.vue")
  },
  {
    name: "user-wallet",
    path: "/user/wallet",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/index.vue")
  },
  {
    name: "casino-casino",
    path: "/casino/:casino(.*)*",
    meta: _91_46_46_46casino_93ZZ92Q7hVJDt92BABr2CzXy_cMuks0WphqjYcxKAWyHwMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/casino/[...casino].vue")
  },
  {
    name: "sports-sports",
    path: "/sports/:sports(.*)*",
    meta: _91_46_46_46sports_93sNtD4sUPqcqhTmxomHczuWHUyHQH_p_3qNRF63cYi_wMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/sports/[...sports].vue")
  },
  {
    name: "user-history-poker",
    path: "/user/history/poker",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/poker.vue")
  },
  {
    name: "user-login-history",
    path: "/user/login-history",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/login-history.vue")
  },
  {
    name: "user-notifications",
    path: "/user/notifications",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/notifications.vue")
  },
  {
    name: "user-history-casino",
    path: "/user/history/casino",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/casino.vue")
  },
  {
    name: "user-history-sports",
    path: "/user/history/sports",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/history/sports.vue")
  },
  {
    name: "perfil-oficial",
    path: "/perfil-oficial",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/perfil-oficial/index.vue")
  },
  {
    name: "games-providers",
    path: "/games/providers",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/providers/index.vue")
  },
  {
    name: "user-irpf-rendimentos",
    path: "/user/irpf-rendimentos",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/irpf-rendimentos.vue")
  },
  {
    name: "vip-tournaments",
    path: "/vip/tournaments",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/tournaments/index.vue")
  },
  {
    name: "promotions-promotion",
    path: "/promotions/:promotion()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/promotions/[promotion].vue")
  },
  {
    name: "games-provider-game",
    path: "/games/:provider()/:game()",
    meta: _91game_93wvtsxY2c0IRn1AG9r9EoI4YTGKxQIbe3K9_Zt2DyEXoMeta || {},
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/[provider]/[game].vue")
  },
  {
    name: "games-jogos-do-padrinho",
    path: "/games/jogos-do-padrinho",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/jogos-do-padrinho.vue")
  },
  {
    name: "perfil-oficial-perfil",
    path: "/perfil-oficial/:perfil()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/perfil-oficial/[perfil].vue")
  },
  {
    name: "user-account-protection",
    path: "/user/account-protection",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/account-protection.vue")
  },
  {
    name: "ver-todos-sectionSlug",
    path: "/ver-todos/:sectionSlug()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/ver-todos/[sectionSlug].vue")
  },
  {
    name: "user-self-self-exclusion",
    path: "/user/self/self-exclusion",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/self/self-exclusion.vue")
  },
  {
    name: "user-wallet-transactions",
    path: "/user/wallet/transactions",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/transactions.vue")
  },
  {
    name: "user-wallet-last-withdraw",
    path: "/user/wallet/last-withdraw",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/wallet/last-withdraw.vue")
  },
  {
    name: "games-providers-provider",
    path: "/games/providers/:provider()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/providers/[provider].vue")
  },
  {
    name: "games-category-category",
    path: "/games/category/:category(.*)*",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/games/category/[...category].vue")
  },
  {
    name: "user-validate-type-token",
    path: "/user/validate/:type()/:token()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/user/validate/[type]/[token].vue")
  },
  {
    name: "vip-tournaments-tournament",
    path: "/vip/tournaments/:tournament()",
    component: () => import("/home/cactus-runner-pipeline/devops/sites/apostatudo-bet-br/pages/vip/tournaments/[tournament].vue")
  },
  {
    path: "/terms",
    redirect: "/page/terms"
  },
  {
    path: "/privacy",
    redirect: "/page/privacy"
  },
  {
    path: "/consent",
    redirect: "/page/consent"
  },
  {
    path: "/lgpd",
    redirect: "/page/lgpd"
  },
  {
    path: "/kyc-policy",
    redirect: "/page/kyc-policy"
  },
  {
    path: "/betting-terms",
    redirect: "/page/betting-terms"
  },
  {
    path: "/pld-ftp-policy",
    redirect: "/page/pld-ftp-policy"
  },
  {
    path: "/responsible-gaming",
    redirect: "/page/responsible-gaming"
  },
  {
    path: "/migrate",
    redirect: "/migrate/confirm"
  }
]